import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface SimpleWarningData {
  warning_title: string;
  warning_description: string;
  warning_sub: string;
  confirmText?: string;
  cancelText?: string;
  showCancelButton?: boolean;
}

@Component({
  selector: "app-warning-popup",
  templateUrl: "./warning-popup.component.html",
})

export class WarningPopupComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<WarningPopupComponent>, @Inject(MAT_DIALOG_DATA) public data: SimpleWarningData,) {}

  title = this.data.warning_title ;
  description = this.data.warning_description;
  subtext = this.data.warning_sub;
  confirmText = this.data.confirmText || "Ok";
  cancelText = this.data.cancelText || "Cancel";
  showCancelButton = this.data.showCancelButton || true;

  ngOnInit() {

    console.log(this.data);
  }

  onNoClick(): void {
    this.dialogRef.close(1);
  }

  onYesClick(): void {
    this.dialogRef.close(2);
  }
}
